<template>
  <div class="maintenanceProjectDetail">
    <div class="step1-container">
      <div class="step-container">
        <div class="step">
          Step1. 維養計畫內容
        </div>
      </div>
      <el-form
        ref="form"
        :model="formData"
        :rules="rules"
        label-width="100px"
      >
        <el-form-item
          label="計畫名稱"
          prop="Name"
        >
          <el-input
            v-if="isAdding"
            v-model="formData.Name"
            placeholder="計畫名稱"
            maxlength="20"
          />
          <div v-else>
            {{ formData.Name }}
          </div>
        </el-form-item>
        <el-form-item
          label="設備廠商"
          prop="SupplierId"
        >
          <el-select
            v-if="isAdding"
            v-model="formData.SupplierId"
            placeholder="設備廠商"
            :disabled="suppliers.length == 0"
          >
            <el-option
              v-for="supplier in suppliers"
              :key="supplier.SupplierId"
              :label="supplier.SupplierName"
              :value="supplier.SupplierId"
            />
          </el-select>
          <div v-else>
            {{ formData.Supplier }}
          </div>
        </el-form-item>
        <el-form-item
          label="預計費用"
          prop="Cost"
        >
          <el-input
            v-if="isAdding"
            v-model="formData.Cost"
            placeholder="預計費用"
            maxlength="20"
            @input="onInput"
          />
          <div v-else>
            {{ formData.Cost }}
          </div>
        </el-form-item>
        <el-form-item
          label="計畫起訖日"
          :required="isAdding"
        >
          <el-col
            v-if="isAdding"
            :span="11"
          >
            <el-form-item prop="StartTime">
              <el-date-picker
                v-model="formData.StartTime"
                type="date"
                placeholder="起始日"
                style="width: 100%;"
              />
            </el-form-item>
          </el-col>
          <el-col
            v-if="isAdding"
            class="line"
            :span="2"
          >
            -
          </el-col>
          <el-col
            v-if="isAdding"
            :span="11"
          >
            <el-form-item prop="EndTime">
              <el-date-picker
                v-model="formData.EndTime"
                type="date"
                placeholder="結束日"
                style="width: 100%;"
              />
            </el-form-item>
          </el-col>
          <div v-if="!isAdding">
            {{ formData.StartTime }} 至 {{ formData.EndTime }}
          </div>
        </el-form-item>
      </el-form>
      <el-button
        v-if="isAdding"
        @click="onCancel"
      >
        取消
      </el-button>
      <el-button
        v-if="isAdding"
        type="primary"
        @click="onSubmit"
      >
        確定
      </el-button>
    </div>
    <div
      v-if="!isAdding"
      class="else-container"
    >
      <div class="step-container">
        <div class="step">
          Step2. 維養項目（總應檢次數／已檢查次數）
        </div>
      </div>
      <div class="function-bar">
        <el-button
          icon="icon-plus"
          round
          @click="clickAdd"
        >
          新增
        </el-button>
      </div>
      <el-table
        :data="itemList"
        style="width: 100%"
      >
        <el-table-column
          type="index"
          width="50"
        />
        <el-table-column
          v-for="item in maintenanceProjectItemStructure"
          :key="item.key"
          :prop="item.key"
          :label="item.label"
        />
        <el-table-column
          label="操作"
          width="120px"
        >
          <template slot-scope="scope">
            <el-button
              size="mini"
              plain
              @click="clickView(scope.row.Id)"
            >
              檢視
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="button-container">
        <el-button
          type="primary"
          @click="backToMaintenance"
        >
          返回維養計畫列表
        </el-button>
      </div>
      <AddMaintenanceItemDialog
        ref="addMaintenanceItemDialog"
        @addedItem="onAddedItem"
      />
    </div>
  </div>
</template>

<script>
import { apiAsset } from '../../../api/smartBuildingSystemAPI'
import { maintenanceProjectItemStructure } from '../models'
import { periodTypeTransfer } from '../utils'
import AddMaintenanceItemDialog from './AddMaintenanceItemDialog'

export default {
  components: {
    AddMaintenanceItemDialog
  },
  data () {
    const formData = {
      Name: '',
      SupplierId: '',
      Supplier: '',
      Cost: '',
      StartTime: '',
      EndTime: ''
    }
    const suppliers = []
    const itemList = []
    return {
      formData,
      maintenanceProjectItemStructure,
      suppliers,
      itemList
    }
  },
  computed: {
    rules () {
      return {
        Name: [
          { required: this.isAdding, message: '必填欄位不可為空', trigger: 'blur' }
        ],
        SupplierId: [
          { required: this.isAdding, message: '必填欄位不可為空', trigger: 'change' }
        ],
        Cost: [
          { required: this.isAdding, message: '必填欄位不可為空', trigger: 'blur' }
        ],
        StartTime: [
          { type: 'date', required: this.isAdding, message: '必填欄位不可為空', trigger: 'change' }
        ],
        EndTime: [
          { type: 'date', required: this.isAdding, message: '必填欄位不可為空', trigger: 'change' },
          { type: 'date', validator: this.checkEndTime, trigger: 'change' }
        ]
      }
    },
    planId () {
      return this.$route.params.planId
    },
    isAdding () {
      return this.$route.params.planId === undefined
    }
  },
  async mounted () {
    if (this.isAdding) {
      await this.getSuppliers()
    } else {
      await this.getMaintenancePlanById(this.planId)
    }
  },
  methods: {
    checkEndTime (rule, value, callback) {
      if (new Date(this.formData.StartTime).getTime() <= new Date(this.formData.EndTime).getTime()) {
        callback()
      } else {
        callback(new Error('起始日不可大於結束日'))
      }
    },
    processItemList (inputItemList) {
      return inputItemList.map(el => ({
        ...el,
        PeriodType: periodTypeTransfer(true, el.PeriodType)
      }))
    },
    async getMaintenancePlanById (id) {
      try {
        const { data } = await apiAsset.maintenance.getMaintenancePlanById(id)
        Object.keys(this.formData).forEach(key => {
          this.formData[key] = data[key]
        })
        this.processBetween()
        this.itemList = this.processItemList(data.Terms)
      } catch (error) {
        console.log(error)
      }
    },
    async getSuppliers () {
      try {
        const { data } = await apiAsset.Asset.GetSuppliers()
        this.suppliers = data
      } catch (error) {
        console.log(error)
      }
    },
    backToMaintenance () {
      this.$router.push({
        name: 'maintenance'
      })
    },
    onInput () {
      this.formData.Cost = this.formData.Cost.replace(/[^0-9]/g, '')
    },
    onCancel () {
      this.backToMaintenance()
    },
    processBetween () {
      this.formData.StartTime = dayjs(this.formData.StartTime).format('YYYY-MM-DD')
      this.formData.EndTime = dayjs(this.formData.EndTime).format('YYYY-MM-DD')
    },
    onSubmit () {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          try {
            const req = {
              ...this.formData,
              StartTime: new Date(this.formData.StartTime).toISOString(),
              EndTime: new Date(this.formData.EndTime).toISOString()
            }
            const res = await apiAsset.maintenance.postMaintenancePlan(req)
            this.formData.Supplier = this.suppliers.find(el => el.SupplierId === this.formData.SupplierId).SupplierName
            this.processBetween()
            this.$router.replace({
              name: 'maintenanceProjectDetailWithPlanId',
              params: {
                planId: res.data.PlanId
              }
            })
          } catch (error) {
            console.log(error)
          }
          this.$message.success('維養計畫新增成功')
        } else {
          this.$message.error('請正確輸入資料')
        }
      })
    },
    clickAdd () {
      this.$refs.addMaintenanceItemDialog.openDialog()
    },
    clickView (itemId) {
      this.$refs.addMaintenanceItemDialog.openDialog(itemId)
    },
    async onAddedItem () {
      try {
        const { data } = await apiAsset.maintenance.getMaintenanceTermsByPlan(this.planId)
        this.itemList = this.processItemList(data)
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.maintenanceProjectDetail {
  padding-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.step-container {
  display: flex;
  justify-content: start;
  margin-bottom: 20px;
  .step {
    display: inline-flex;
    margin: unset;
    width: unset;
    text-align: start;
    color: #fff;
    background-color: $mainColor;
    padding: 0px 20px 0px 20px;
    font-size: 17px;
    line-height: 40px;
    font-weight: normal;
    position: relative;
    &::after {
      content: "";
      position: absolute;
      top: 0;
      right: -20px;
      width: 0;
      height: 0;
      border-top: 20px solid transparent;
      border-bottom: 20px solid transparent;
      border-left: 20px solid $mainColor;
      z-index: 2;
      transition: border-color 0.2s ease;
    }
  }
}
::v-deep .el-form {
  display: flex;
  flex-wrap: wrap;
  column-gap: 20px;
  row-gap: 0px;
  .el-form-item {
    margin-right: 0;
    flex: 0 0 calc(50% - 10px);
    margin-right: 0;
    label {
      text-align: left;
    }
  }
  .el-select {
    width: 100%;
  }
}
.function-bar {
  display: flex;
  justify-content: end;
  margin-bottom: 20px;
}
.else-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
::v-deep .el-table {
  @include basicTable();
}
</style>
